import PayPalExpress from './paypal-express';
import PayPalExpressEditModal from './edit-modal';

export default PayPalExpress;
export { PayPalExpressEditModal };
